<template>
  <div>
    <div
      class="add-to-home j-add-to-home"
      @click="isSafari ? showSafariTip() : installPwa()"
    >
      <Icon class="ico" name="add-desktop"></Icon>
      <span class="text">{{ letter.voucherAddHome }}-{{visibleInstallAwardPopup}}</span>
      <transition name="fade">
        <div class="pwa-popover flex-center" v-if="!showAccountSelecter">
          <img
            v-if="popoverIco"
            class="popover-ico"
            :src="popoverIco"
            alt="popover-ico"
          />
          <span class="popover-text">{{ letter.v3AddShortcutForBonus }}</span>
          <div class="sanjiao"></div>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <safari-pwa-guide-popup
        v-if="isGuide"
        @closePopup="hideSafariTip"
      ></safari-pwa-guide-popup>
    </transition>
    <transition name="fade">
      <pwa-install-award-popup
        v-if="visibleInstallAwardPopup"
        @install="pwaInstallFromPopup"
        @close="closePwaInstallAwardPopup"
      ></pwa-install-award-popup>
    </transition>
    <transition name="fade">
      <pwa-goto-award-tips-popup
        v-if="visibleGotoAwardTipsPopup"
        @close="switchVisibleGotoAwardTipsPopup(false)"
      ></pwa-goto-award-tips-popup>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import { isSafari } from '@utiles/officialStore/device';
import SafariPwaGuidePopup from '@components/officialTopup/pwa/SafariPwaGuidePopup.vue';
import PwaInstallAwardPopup from '@components/officialTopup/pwa/PwaInstallAwardPopup.vue';
import PwaGotoAwardTipsPopup from '@components/officialTopup/pwa/PwaGotoAwardTipsPopup.vue';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  popupType,
  showPopup,
  clickButton
} from '@plugins/biPoint/_configWebstoreV3';
import {
  UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP,
  UPDATE_IS_INSTALL
} from '@store/officialTopup/page';
export default {
  components: { SafariPwaGuidePopup, PwaInstallAwardPopup, PwaGotoAwardTipsPopup },
  name: 'PwaInstall',
  data() {
    return {
   
      isSafari: isSafari(),
      isGuide: false,
      isHideAdd:
        globalConfig.getHrefParam('cid') === 'shortcut' ||
        globalConfig.getHrefParam('scid').includes('shortcut'),
      visibleInstallAwardPopup: false,
    };
  },
  computed: {
    ...mapState({
      openPwa: state => state.page.openPwa,
      visibleGotoAwardTipsPopup: state => state.page.visibleGotoAwardTipsPopup
    }),
    ...mapGetters(['isJpPlatform']),
    popoverIco() {
      return this.$store.state.page.picList?.pwagift;
    },
    letter() {
      return this.$store.state.letter;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    showAccountSelecter() {
      return this.$store.state.login.showAccountSelecter;
    },
    isInstall() {
      return this.$store.state.page.isInstall.value;
    }
  },
  watch:{
    isInstall(newVal) {
      if(newVal == false) {
        this.isAutoShowPwaPopup();
      }
    }
  },
  mounted() {
    this.isAutoShowPwaPopup();
    // app安装了
    window.addEventListener('appinstalled', () => {
      this.setIsInstall();
      // 回收 deferredPrompt 变量
      window.deferredPrompt = null;
      // pwa成功安装
      commonEmitUpload('success-install-pwa', {
        event: 'success-install-pwa',
        newPage: false,
        type: 'change'
      });
    });
  },
  methods: {
    setIsInstall() {
      this.$store.commit(UPDATE_IS_INSTALL, true);
    },
    showSafariTip() {
      this.isGuide = true;
      clickButton({
        btnName: 'add_to_screen',
        locationKey: this.$route.meta.pageName
      });
      showPopup(popupType.safariAddToHomePopup);
    },
    hideSafariTip() {
      this.isGuide = false;
      this.switchVisibleGotoAwardTipsPopup(true);
    },
    updateUrlWithParams(currentUrl, newParams) {
      // 解析当前 URL
      const url = new URL(currentUrl);
      // 遍历并更新/添加新的查询参数
      Object.keys(newParams).forEach(key => {
        url.searchParams.set(key, newParams[key]);
      });
      // 返回更新后的 URL 字符串
      return url.toString();
    },
    installPwa() {
      // 用户点击页面上的安装按钮
      commonEmitUpload('click-install-pwa-btn', {
        event: 'click-install-pwa-btn',
        newPage: false,
        type: 'click'
      });
      clickButton({
        btnName: 'add_to_screen',
        locationKey: this.$route.meta.pageName
      });
      if (!window.deferredPrompt) return;
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then(result => {
        if (result.outcome == 'dismissed') {
          // 用户点击页面上的安装按钮
          commonEmitUpload('cancel-install-pwa', {
            event: 'cancel-install-pwa',
            newPage: false,
            type: 'click'
          });
        } else if (result.outcome == 'accepted') {
          window.setIsInstall();
          this.setIsInstall();
          window.deferredPrompt = null;


          // 用户点击页面上的安装按钮
          commonEmitUpload('accept-install-pwa', {
            event: 'accept-install-pwa',
            newPage: false,
            type: 'click'
          });

          // 2026-01-21 存一下，用来刷新页面后展示领奖提示弹窗
          try {
             sessionStorage.setItem(`${this.gameId}_pwa_install_click`, 1);
          } catch (error) {
            
          }

          // 2025-01-08 同manifest动态生成的参数链接一致
          const curCid = globalConfig.getHrefParam('cid');
          const curScid = globalConfig.getHrefParam('scid');
          try {
            let link = this.updateUrlWithParams(window.location.href, {
              cid: curCid,
              scid: curScid,
              mode: 'pwa'
            });
            window.location.href = window.globalGetGotoLink({ link });
          } catch (e) {
            console.error(e);
          }
        }
      });
    },
    pwaInstallFromPopup() {
      this.closePwaInstallAwardPopup();
      this.isSafari ? this.showSafariTip(true) : this.installPwa(true);
    },
    closePwaInstallAwardPopup() {
      this.visibleInstallAwardPopup = false;
    },
    switchVisiblePwaInstallAwardPopup(bool) {
      if (!this.openPwa) return;
      this.visibleInstallAwardPopup = bool;
      if (bool) {
        // 记录本次打开的时间点
        window?.localStorage?.setItem(
          `lastShowPwaInstallPopupDate${this.gameId}v2`,
          new Date().getTime()
        );
        // 打点上报
        showPopup(popupType.pwaInstallPopup);
      }
    },
    isAutoShowPwaPopup() {
        // 2026-01-21 如果已经安装或者从pwa打开，就不弹窗
     if((this.isInstall && !this.isSafari)  || this.isHideAdd) return;
      const lastShowPwaInstallPopupDate = window?.localStorage?.getItem(
        `lastShowPwaInstallPopupDate${this.gameId}v2`
      );
      if (lastShowPwaInstallPopupDate) {
        const lastDate = new Date(
          Number(lastShowPwaInstallPopupDate)
        ).getTime();
        const nowDate = new Date().getTime();
        // 如果是7天之前就展示
         // 2026-01-21 现在改成3天
        if (nowDate - lastDate > 3 * 24 * 60 * 60 * 1000) {
          this.switchVisiblePwaInstallAwardPopup(true);
        }
      } else {
        this.switchVisiblePwaInstallAwardPopup(true);
      }
    },
    switchVisibleGotoAwardTipsPopup(bool) {
      this.$store.commit(UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP, bool);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';

.add-to-home {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  height: 45px;
  box-sizing: border-box;
  border-radius: 30px;
  cursor: pointer;
  margin-right: 20px;
  font-size: 22px;
  color: #fff;
  border: 1px solid $themeColor;
  position: relative;
  .ico {
    display: block;
    margin-right: 10px;
    color: $themeColor;
    width: 30px;
    height: 26px;
  }
  .pwa-popover {
    max-width: 500px;
    min-width: 287px;
    background-color: #fe8f0d;
    border-radius: 6px;
    display: none;
    position: absolute;
    top: 60px;
    box-sizing: border-box;
    padding: 10px;
    text-align: center;
    font-size: 18px;
    line-height: 1.2;

    .popover-ico {
      margin-right: 10px;
      width: 28px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .sanjiao {
      position: absolute;
      top: -10px;
      left: 50%;
      margin-left: -10px;
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 15px solid #fe8f0d;
    }
  }
}

@media screen and (orientation: landscape) {
  .add-to-home {
    font-size: 16px;
    .pwa-popover {
      display: flex;
    }
  }
}
</style>
